module.exports = __webpack_public_path__ + "img/ancient_of_eternity_small.13eaa0d8.png";